import { useMemo } from 'react';
export const useBrowserLanguage = () => useMemo(() => {
    const lang = navigator.language || navigator.languages?.[0] || 'en';
    return lang.split('-')[0];
}, []);
